import { render, staticRenderFns } from "./ListTermsAndConditions.vue?vue&type=template&id=34ab28bb&scoped=true"
import script from "./ListTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./ListTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./ListTermsAndConditions.vue?vue&type=style&index=0&id=34ab28bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab28bb",
  null
  
)

export default component.exports